function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.83501 5.83491C2.4293 9.24063 2.4293 14.7594 5.83501 18.1651C9.24072 21.5708 14.7595 21.5708 18.1652 18.1651C21.5709 14.7594 21.5709 9.24062 18.1652 5.83491C14.7595 2.4292 9.24072 2.4292 5.83501 5.83491ZM16.6413 10.5955C16.875 10.5955 17.0639 10.7844 17.0639 11.0181L17.0614 12.9844C17.0614 13.2181 16.8725 13.407 16.6388 13.407L13.3922 13.3921L13.4046 16.6412C13.4046 16.8749 13.2157 17.0638 12.982 17.0638L11.0157 17.0613C10.782 17.0613 10.5931 16.8724 10.5931 16.6387L10.608 13.3921L7.35888 13.4045C7.1252 13.4045 6.93627 13.2156 6.93627 12.9819L6.93627 11.0131C6.93627 10.7794 7.1252 10.5905 7.35888 10.5905L10.608 10.6079L10.5955 7.35878C10.5955 7.1251 10.7845 6.93617 11.0182 6.93617L12.987 6.93617C13.2207 6.93617 13.4096 7.1251 13.4096 7.35878L13.3922 10.6079L16.6413 10.5955Z",
  fill: "#2BD978"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Plus.5aa1c16b.svg";
export { ForwardRef as ReactComponent };